import React, { useState, useEffect } from 'react';
// Tái sử dụng CSS của trang Vùng Nguyên Liệu cho đồng bộ
import styles from '../RawMaterialPage/RawMaterialPage.module.scss'; 
import productService from '../../services/productService';

const BACKEND_URL = 'https://huongtramcomoc.vn';

const AboutPage = () => {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    // Gọi API với slug 'gioi-thieu'
    productService.getPageContent('gioi-thieu')
      .then(res => setPageData(res.data))
      .catch(err => console.error(err));
  }, []);

  if (!pageData) return <div className={styles.loading}>Đang tải dữ liệu...</div>;

  return (
    <div className={styles.pageContainer}>
      {/* Banner ảnh đại diện */}
      {pageData.featured_image_url && (
        <div className={styles.bannerImage}>
          <img src={`${BACKEND_URL}${pageData.featured_image_url}`} alt={pageData.title} />
           <div className={styles.bannerOverlay}></div>
           <h1 className={styles.pageTitleOnBanner}>{pageData.title}</h1>
        </div>
      )}

      {/* Tiêu đề nếu không có banner */}
      {!pageData.featured_image_url && (
         <h1 className={styles.pageTitle}>{pageData.title}</h1>
      )}

      <div 
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: pageData.content }} 
      />
    </div>
  );
};
export default AboutPage;